import { Box } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Card } from '../../../shared/components/ui/Card';
import { ModalDelete } from '../components/ModalDelete';
import { useVehicle } from '../context/useVehicle';
import { PageHeader } from '../components/VehicleDetail/PageHeader';
import { ActionButtons } from '../components/VehicleDetail/ActionButtons';
import { VehicleInfo } from '../components/VehicleDetail/VehicleInfo';

export default function VehicleDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Usar o vehicle do state da rota anterior, se disponível
  const vehicleFromState = location.state?.vehicle;
  console.log('vehicleFromState',vehicleFromState);
  
  const { 
    vehicleData, 
    isDataLoading, 
    openDeleteModal, 
    isDeleteModalOpen, 
    closeDeleteModal, 
    handleDeleteVehicle, 
    isDeleting, 
    navigateToEdit 
  } = useVehicle();

  // Usar o vehicle do state se disponível, senão usar o vehicleData da API
  const vehicle = vehicleFromState || vehicleData;

  // Se não tem vehicle do state e está carregando da API, mostrar loading
  if (!vehicleFromState && isDataLoading) return null;
  // Se não tem vehicle nem do state nem da API, não mostrar nada
  if (!vehicle) return null;

  console.log('vehicle',vehicle);
  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: '#F6F8FB', minHeight: '100vh' }}>
      <Card sx={{ background: '#fff', borderRadius: 4, p: 4, maxWidth: 900, margin: '32px auto', boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' }}>
        <PageHeader onBack={() => navigate('/vehicles')} />
        <ActionButtons 
          onEdit={() => navigateToEdit(vehicle.attributeId)} 
          onDelete={() => openDeleteModal(vehicle)} 
        />
        <VehicleInfo vehicle={vehicle} />

        <ModalDelete
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteVehicle}
          loading={isDeleting}
          vehicleName={`${vehicle.marca} ${vehicle.modelo}`}
        />
      </Card>
    </Box>
  );
} 